import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ZoomMap from './pages/ZoomMap';
import Overview from './pages/Overview';
import { MasterContext } from './context/MasterContextProvider';
import Loading from './pages/Loading';
import ErrorGetTransits from './pages/ErrorGetTransits';
import DialogPlacer from './pages/DialogPlacer';
import NoOperation from './pages/NoOperation';
import UpdateTime from './pages/UpdateTime';

export const URLs = {
  index: '/', //トップ
  overview: '/', //全体図
  zoomMap: 'zoom' //拡大図
};
Object.freeze(URLs);

export const RouterConfig: React.FC = () => {
  const { master } = useContext(MasterContext);

  return (
    <>
      {master.stations.length === 0 ? (
        // マスターデータ未取得時はLoading画面
        <Loading></Loading>
      ) : (
        <>
          <BrowserRouter basename={process.env.REACT_APP_ROOT_PATH}>
            <Routes>
              <Route path={`/${URLs.overview}`} element={<Overview />} />
              <Route
                path={`/${URLs.zoomMap}/:stationNo`}
                element={<ZoomMap />}
              />
              <Route path={`/${URLs.zoomMap}/`} element={<ZoomMap />} />
            </Routes>
          </BrowserRouter>
          {/* マスターデータ取得後の共通コンポーネント */}
          <UpdateTime></UpdateTime>
          <DialogPlacer></DialogPlacer>
          <NoOperation></NoOperation>
          <ErrorGetTransits></ErrorGetTransits>
        </>
      )}
    </>
  );
};
